import classnames from "classnames";
import { Component } from "react";
import ReactDOM from "react-dom";
import { type ReactNode } from "react";

import ArrowBackIcon from "nvent-web/assets/svg/arrow-left.svg";

import LocalePicker from "nvent-web/scenes/Auth/components/LocalePicker";
import Header from "../Header";

import style from "./HeaderTitle.module.scss";
import { withRouter, type WithRouterProps } from "~/nvent-web/utils/withRouter";
import compose from "~/nvent-web/utils/compose";

export interface HeaderTitleProps extends WithRouterProps {
  hideBackButton?: boolean;
  children: ReactNode;
}

class HeaderTitle extends Component<HeaderTitleProps> {
  private el: HTMLElement;

  constructor(props: HeaderTitleProps) {
    super(props);

    this.el = document.createElement("div");
    this.el.classList.add(style.headerContent);
  }

  componentDidMount() {
    const title = Header.getTitleContainer();

    if (title) {
      title.appendChild(this.el);
    }
  }

  componentWillUnmount() {
    const title = Header.getTitleContainer();

    if (title) {
      title.removeChild(this.el);
    }
  }

  renderHeaderTitle() {
    const { hideBackButton } = this.props;

    return (
      <>
        {!hideBackButton && (
          <div
            className={style.arrowIconContainer}
            onClick={this.onGoBack}
            role="button"
            tabIndex={0}
          >
            <img src={ArrowBackIcon} />
          </div>
        )}
        <div
          className={classnames(style.titleContainer, {
            [style.hasBackButton]: !hideBackButton,
          })}
        >
          {this.props.children}
        </div>
        <div className={style.picker}>
          <LocalePicker dark />
        </div>
      </>
    );
  }

  render() {
    return ReactDOM.createPortal(this.renderHeaderTitle(), this.el);
  }

  private onGoBack = () => {
    this.props.navigate(-1);
  };
}

const HeaderTitleComponent =
  compose<Pick<HeaderTitleProps, "children" | "hideBackButton">>(withRouter)(
    HeaderTitle
  );

HeaderTitleComponent.displayName = "HeaderTitle";

export default HeaderTitleComponent;
